import { render, staticRenderFns } from "./ClientDragAndDropRawFile.vue?vue&type=template&id=c48f6d34&scoped=true&"
import script from "./ClientDragAndDropRawFile.vue?vue&type=script&lang=js&"
export * from "./ClientDragAndDropRawFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48f6d34",
  null
  
)

export default component.exports